import { Map as ImmutableMap, Record } from "immutable";

const defaults = {
    __pricing: ImmutableMap,
    __size: "",
    __size_group: "",
    _id: undefined,
    __units_per_pack: undefined,
    __weight: undefined,
};

export interface ISizeRecord extends Record<any, any> {
    _id: string;
    __size: string;
    __size_group: string;
    __units_per_pack: number;
    __weight: number;
    __pricing: ImmutableMap<string, any>;
}

export const createSizeRecord = (schema) => {
    const sizeDefaults = defaults;
    schema.fields.forEach((field) => {
        const keySplit = field.key.split(".");
        if (keySplit.length > 1) {
            sizeDefaults[keySplit[1]] = undefined;
        }
    });
    class Size extends Record(sizeDefaults) {
        declare __pricing: ImmutableMap<string, any>;
        declare _id: string;
        declare __size: string;
        declare __size_group: string;
        declare __units_per_pack: number;
        declare __weight: number;

        constructor(args: any = {}) {
            super({
                ...args,
                __pricing: ImmutableMap(args.__pricing && args.__pricing.map((val) => [val.__currency_code, val])),
            });
        }

        toJS() {
            const js = super.toJS();
            js.__pricing = Object.keys(js.__pricing).map((key) => js.__pricing[key]);
            Object.keys(js).forEach((key) => {
                if (typeof js[key] === "undefined") {
                    delete js[key];
                }
            });
            return js;
        }

        get _name() {
            return this.__size.replace(this.__size_group, "");
        }
    }
    return Size;
};
